import { setUpMobileHamburgerMenu } from 'js/simple_layout/header/setUpHeader';
import { throttle } from 'lodash';

function setUpStickyCtas(): void {
  let showingStickyCtas = false;

  const stickyCtasContainer = document.querySelector('.js-loswp-sticky-ctas');
  if (!stickyCtasContainer) return;

  const embeddedDocument = document.querySelector(
    '.js-loswp-embedded-document',
  ) as HTMLElement;

  // variant_g3_early_sticky_footer: show the footer as soon as the top work-card CTA row scrolls
  // off the top of the viewport, instead of when the document scrolls into view. The near-bottom
  // hide behavior below is unchanged. Default arms keep the document-in-view trigger.
  const triggerOnTopCtasOffscreen =
    stickyCtasContainer.getAttribute('data-sticky-trigger') ===
    'top_ctas_offscreen';
  const topCtas = triggerOnTopCtasOffscreen
    ? document.querySelector('.js-loswp-work-card-ctas')
    : null;

  // This is a hardcoded hack because when fetching the height of the element, it's 0
  // Note that if the designs change for the sticky ctas, this will need to be updated :\
  const stickyCtasHeight = 96;

  const stickyScrollHandler = throttle(() => {
    const scrollPosition = window.scrollY;
    const topOfEmbeddedDocument = embeddedDocument.offsetTop;
    const bottomOfEmbeddedDocument =
      topOfEmbeddedDocument + embeddedDocument.offsetHeight;

    const ctasStickToBottomOfPage = window.innerWidth <= 1280;
    const responsiveStickyCtasLowerCutoff = ctasStickToBottomOfPage
      ? bottomOfEmbeddedDocument - window.innerHeight
      : bottomOfEmbeddedDocument - stickyCtasHeight;

    // Upper (show) trigger: g3 shows once the top CTA row is above the viewport; default shows
    // once the document top is scrolled past.
    const pastUpperTrigger =
      topCtas != null
        ? topCtas.getBoundingClientRect().bottom <= 0
        : scrollPosition > topOfEmbeddedDocument;
    const shouldShowStickyCtas =
      pastUpperTrigger && scrollPosition < responsiveStickyCtasLowerCutoff;

    if (shouldShowStickyCtas && !showingStickyCtas) {
      showingStickyCtas = true;
      stickyCtasContainer.classList.remove('hidden');
    } else if (!shouldShowStickyCtas && showingStickyCtas) {
      showingStickyCtas = false;
      stickyCtasContainer.classList.add('hidden');
    }
  }, 250);
  window.addEventListener('scroll', stickyScrollHandler);
}

export const setUpHeaders = () => {
  setUpMobileHamburgerMenu();
  setUpStickyCtas();
};
